import { render, staticRenderFns } from "./AdminOverview.vue?vue&type=template&id=05aa15b1&scoped=true&"
import script from "./AdminOverview.vue?vue&type=script&lang=js&"
export * from "./AdminOverview.vue?vue&type=script&lang=js&"
import style0 from "./AdminOverview.vue?vue&type=style&index=0&id=05aa15b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aa15b1",
  null
  
)

component.options.__file = "AdminOverview.vue"
export default component.exports